import type { UnitKind } from "@empire/core-sim";
import { useState } from "react";
import { UNIT_RADIUS, UNIT_SHAPE, UNIT_TINT } from "../theme/glyphs.js";

/**
 * The same troop artwork in the planner, training and replay legends (D-121).
 * The established semantic glyph survives an image-loading failure.
 */
export function UnitMark({ kind, size = 14 }: { kind: UnitKind; size?: number }): JSX.Element {
  const [failed, setFailed] = useState(false);
  if (!failed)
    return (
      <img
        className="unit-portrait shrink-0"
        src={`${import.meta.env.BASE_URL}art/portraits/${kind}.webp`}
        width={size}
        height={size}
        style={{ width: size, height: size }}
        alt=""
        aria-hidden="true"
        onError={() => setFailed(true)}
      />
    );
  return <UnitGlyph kind={kind} size={size} />;
}

function UnitGlyph({ kind, size }: { kind: UnitKind; size: number }): JSX.Element {
  const r = (UNIT_RADIUS[kind] / 7) * (size / 2) * 2; // ram (7) fills the box
  const c = size / 2;
  const fill = UNIT_TINT[kind];
  const shape = UNIT_SHAPE[kind];

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
      {shape === "square" ? (
        <rect x={c - r} y={c - r} width={r * 2} height={r * 2} fill={fill} />
      ) : shape === "triangle" ? (
        <polygon points={`${c},${c - r} ${c + r},${c + r} ${c - r},${c + r}`} fill={fill} />
      ) : shape === "diamond" ? (
        <polygon points={`${c},${c - r} ${c + r},${c} ${c},${c + r} ${c - r},${c}`} fill={fill} />
      ) : (
        <circle cx={c} cy={c} r={r} fill={fill} />
      )}
    </svg>
  );
}
